<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Draggable FAQ List</div>
                <button type="submit" v-on:click.prevent="addFAQ" class="btn btn-primary waves-effect pull-right">Add</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <draggable v-model="questionList" v-on:change="changePosition()" class="drag-view">
                        <template v-for="(text, index) in questionList">
                            <div class="card">
                                <div class="ml-10 margin-faq card-body">
                                    <router-link title='Edit FAQ' v-bind:to="{name: 'UpdateFAQ',params:{id:text.id}}">
                                        <span class="faqQuestion" :key="index">{{text.question}}</span>
                                    </router-link>
                                </div>
                                <button class="btn btn-danger deleteMedia deleteFaq"  v-on:click.prevent="deleteFAQ(text.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                            </div>
                            <!--<div class="clearfix"></div>-->
                        </template>
                    </draggable>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
</template>

<script>
    import $ from 'jquery';
    import draggable from 'vuedraggable';
    import BackendFooter from '@/components/backend/partials/Footer';
    import Vue from "vue";
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    var self;
    export default {
        name: 'List_Media',
        mixins: [SessioMixin],
        components: {
            draggable,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                questionList: [],
                questionPosition: [],
            }
        },
        computed: {

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            self.showLoader();
            self.getFAQ();
        },

        methods: {
            addFAQ() {
                self.$router.push('/backend/addfaq');
            },
            deleteFAQ: function (id) {
                //console.log(id);
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        delete: id,
                    }
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.delete("deletefaq", config)
                                .then(function (response) {
                                    self.getFAQ();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal('Deleted', 'You successfully deleted the FAQ.', 'success');
                        /*self.$swal({
                         type: 'success',
                         text: 'You successfully deleted the FAQ.',
                         showConfirmButton: false,
                         timer: 3000,
                         });*/
                    } else {
                        self.$swal('Cancelled', 'Your FAQ still intact', 'info')
                    }
                });
            },
            getFAQ() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                /*var fields = {
                 limit: 2,
                 };*/
                self.showLoader();
                HTTP.post("getfaq", '', config)
                        .then(function (response) {
                            self.questionList = response.data.content;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            changePosition() {
                var fields = {
                    questionList: self.questionList,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("changepositionfaq", fields, config)
                        .then(function (response) {
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/faq/DraggableListFAQ.vue